import { oz } from '@weft/utils';

export const StripeCreateInvoiceResponseSchema = oz.array(oz.object({
  invoiceId: oz.string().min(1),
  stripeInvoiceId: oz.string().min(1),
  stripeInvoicePaymentLink: oz.string().optional(),
})).openapi('stripeCreateInvoiceResponse');

export type StripeCreateInvoiceResponse = oz.infer<typeof StripeCreateInvoiceResponseSchema>;